import { useContext } from 'react'
import AnalyticsContext from './context'
import { Analytics } from '.'

const useAnalytics = (): Analytics => useContext(AnalyticsContext)

export default useAnalytics
